import { render, staticRenderFns } from "./ElegantCRM.vue?vue&type=template&id=2df2fc5e&scoped=true&"
import script from "./ElegantCRM.vue?vue&type=script&lang=js&"
export * from "./ElegantCRM.vue?vue&type=script&lang=js&"
import style0 from "./ElegantCRM.vue?vue&type=style&index=0&id=2df2fc5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df2fc5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
